import { render, staticRenderFns } from "./ExtraAuth.vue?vue&type=template&id=133e8d74&scoped=true&"
import script from "./ExtraAuth.vue?vue&type=script&lang=js&"
export * from "./ExtraAuth.vue?vue&type=script&lang=js&"
import style0 from "./ExtraAuth.vue?vue&type=style&index=0&id=133e8d74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133e8d74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
